import type { Columns } from '@/types/table';

// Common columns that don't change between property and order views
const COMMON_COLUMNS: Columns[] = [
  {
    name: '',
    selector: 'state',
    type: 'component',
    width: '5px',
    isSortableByHeader: false
  },
  {
    name: 'File Name',
    selector: 'fileName',
    type: 'text',
    width: '320px'
  },
  {
    name: 'Uploaded Date',
    selector: 'uploadedTimestamp',
    type: 'dateTime',
    width: '196px',
    isSort: true
  },
  {
    name: 'Uploaded By',
    selector: 'uploadedBy',
    width: '154px',
    type: 'text',
    isSort: true
  }
];

export const PROPERTY_COLUMNS: Columns[] = [
  ...COMMON_COLUMNS,
  {
    name: 'Property Added',
    selector: 'success',
    type: 'component',
    width: '180px',
    isSortableByHeader: true
  },
  {
    name: 'Property Failed',
    selector: 'failed',
    type: 'component',
    width: '195px',
    isSortableByHeader: true
  },
  {
    name: 'Action',
    selector: 'action',
    type: 'component',
    width: '154px',
    isSortableByHeader: false
  }
];

export const ORDER_COLUMNS: Columns[] = [
  ...COMMON_COLUMNS,
  {
    name: 'Order Accepted/Placed',
    selector: 'success',
    type: 'component',
    width: '222px',
    isSortableByHeader: true
  },
  {
    name: 'Order Rejected',
    selector: 'failed',
    type: 'component',
    width: '170px',
    isSortableByHeader: true
  },
  {
    name: 'Action',
    selector: 'action',
    type: 'component',
    width: '154px',
    isSortableByHeader: false
  }
];
